import React from "react";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './sidebar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from "react";
import { Link, useLocation } from 'react-router-dom';

import {
    faHouse,
    faGaugeSimple,
    faTachometerAlt,
    faBars,
    faMicrochip,
    faToolbox,
    faSign,
    faDatabase,
    faContactBook,
    faUsers,
    faInstitution,
    faArrowLeft,
    faCircleArrowLeft,
    faCircleArrowRight,
    faArrowAltCircleDown,
    faArchive,
    faSignOut, faBarsProgress,
    faUser,
    faChevronDown,
    faPlus,
    faNetworkWired,
    faCog,
    faGlobe
} from "@fortawesome/free-solid-svg-icons";
import { faEdit } from '@fortawesome/free-regular-svg-icons';
import { faDev } from '@fortawesome/free-brands-svg-icons';
import { getCurrentUser, logout } from "./axiosInstance";

const navItems = [
    { path: '/', name: 'Main Dashboard', id: 'navItemMainDashboard', icon: faBars },
    { path: '/device', name: 'Devices', id: 'navItemDevices', icon: faMicrochip },
    { path: '/organization', name: 'Organization', id: 'navItemOrganizations', icon: faInstitution },
    { path: '/custom_user', name: 'Users', id: 'navItemUsers', icon: faUsers },
    { path: '/contact', name: 'Contacts', id: 'navItemContacts', icon: faContactBook },
    { path: '/realtime_log/static', name: 'Data', id: 'navItemData', icon: faDatabase },
    { path: '/signature', name: 'Signature', id: 'navItemSignature', icon: faSign },
    { path: '/setting', name: 'Settings', id: 'navItemSettings', icon: faToolbox },
    { path: '/archive', name: 'Device Archive', id: 'navItemArchive', icon: faArchive },
];

let itemShow = true;

function toggleNav() {
    const sidebarMenu = document.getElementById('sidebarMenu');
    const sidebarCategories = document.querySelector('.sidebar-categories');
    const sidebarLogo = document.querySelector('.sidebar-logo span');
    const idBtnClose = document.getElementById('id_btn_open');
    const idBtnOpen = document.getElementById('id_btn_close');
    
    if (itemShow) {
        // Collapse
        if (sidebarCategories) sidebarCategories.style.display = 'none';
        if (sidebarLogo) sidebarLogo.style.display = 'none';
        if (sidebarMenu) sidebarMenu.style.width = '70px';
        idBtnClose.style.display = 'none';
        idBtnOpen.style.display = 'block';
        itemShow = false;
    } else {
        // Expand
        if (sidebarCategories) sidebarCategories.style.display = 'block';
        if (sidebarLogo) sidebarLogo.style.display = 'block';
        if (sidebarMenu) sidebarMenu.style.width = '250px';
        idBtnClose.style.display = 'block';
        idBtnOpen.style.display = 'none';
        itemShow = true;
    }
}

export default function Header({ childToParent }) {
    const location = useLocation();
    const [toggleNavIcon, setToggleNavIcon] = useState(faCircleArrowLeft);
    const [expandedCategories, setExpandedCategories] = useState({
        monitoring: true,
        devices: true,
        management: true,
        settings: false
    });

    const handleNavClick = (item) => {
        // childToParent(item.id);
    };

    const toggleCategory = (category) => {
        setExpandedCategories(prev => ({
            ...prev,
            [category]: !prev[category]
        }));
    };

    const user = JSON.parse(localStorage.getItem('user'));
    console.log('User data in Header:', user);
    
    const fullName = [user?.first_name, user?.last_name].filter(Boolean).join(' ') || user?.name || user?.username;
    console.log('Displaying full name:', fullName);

    const getPageTitle = (pathname) => {
        return 'Dashboard';
    };
    const pageTitle = getPageTitle(location.pathname);

    // Sidebar categories
    const sidebarCategories = [
        {
            id: 'monitoring',
            label: '📊 MONITORING',
            color: '#78909c',
            items: [
                { path: '/', name: 'Dashboard', icon: faBars },
                { path: '/realtime_log/static', name: 'Real-time Data', icon: faDatabase }
            ]
        },
        {
            id: 'devices',
            label: '🖥️ DEVICES',
            color: '#90a4ae',
            items: [
                { path: '/device', name: 'Devices', icon: faMicrochip },
                { path: '/archive', name: 'Device Archive', icon: faArchive }
            ]
        },
        {
            id: 'management',
            label: '👥 MANAGEMENT',
            color: '#84a0ab',
            items: [
                { path: '/custom_user', name: 'Users', icon: faUsers },
                { path: '/organization', name: 'Organizations', icon: faInstitution },
                { path: '/contact', name: 'Contacts', icon: faContactBook }
            ]
        },
        {
            id: 'settings',
            label: '⚙️ SETTINGS',
            color: '#607d8b',
            items: [
                { path: '/signature', name: 'Signature', icon: faSign },
                { path: '/setting', name: 'Settings', icon: faToolbox }
            ]
        }
    ];

    return (
        <div>
            <header id='idforheader'>
                <nav id="sidebarMenu" className="d-lg-block sidebar" style={{ 
                    backgroundColor: '#ffffff',
                    borderRight: '1px solid #e8eaed',
                    boxShadow: '2px 0 4px rgba(0,0,0,0.02)'
                }}>
                    <div className="position-sticky">
                        {/* Sidebar Header */}
                        <div className="sidebar-header" style={{
                            padding: '20px 16px',
                            borderBottom: '1px solid #e8eaed'
                        }}>
                        </div>

                        {/* Categorized Sidebar Menu */}
                        <div className="sidebar-categories" style={{ padding: '16px 0' }}>
                            {sidebarCategories.map((category) => (
                                <div key={category.id} style={{ marginBottom: '16px' }}>
                                    {/* Category Header */}
                                    <div
                                        onClick={() => toggleCategory(category.id)}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            padding: '6px 20px',
                                            cursor: 'pointer',
                                            userSelect: 'none',
                                            color: '#5f6368',
                                            fontWeight: '600',
                                            fontSize: '11px',
                                            textTransform: 'uppercase',
                                            letterSpacing: '1px',
                                            transition: 'color 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.color = '#202124';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.color = '#5f6368';
                                        }}
                                    >
                                        <span>{category.label}</span>
                                        <FontAwesomeIcon 
                                            icon={faChevronDown} 
                                            style={{
                                                fontSize: '9px',
                                                transition: 'transform 0.2s ease',
                                                transform: expandedCategories[category.id] ? 'rotate(0deg)' : 'rotate(-90deg)',
                                                color: '#80868b'
                                            }}
                                        />
                                    </div>

                                    {/* Category Items */}
                                    {expandedCategories[category.id] && (
                                        <div style={{ marginTop: '4px' }}>
                                            {category.items.map((item, index) => {
                                                const isActive = location.pathname === item.path;
                                                return (
                                                    <Link key={index} to={item.path} className="nav-link" style={{ textDecoration: 'none' }}>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                padding: '10px 20px',
                                                                margin: '2px 8px',
                                                                borderRadius: '8px',
                                                                color: isActive ? '#1a73e8' : '#5f6368',
                                                                backgroundColor: isActive ? '#e8f0fe' : 'transparent',
                                                                fontWeight: isActive ? '500' : '400',
                                                                fontSize: '14px',
                                                                cursor: 'pointer',
                                                                transition: 'all 0.15s ease',
                                                                gap: '12px'
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                if (!isActive) {
                                                                    e.currentTarget.style.backgroundColor = '#f1f3f4';
                                                                    e.currentTarget.style.color = '#202124';
                                                                }
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                if (!isActive) {
                                                                    e.currentTarget.style.backgroundColor = 'transparent';
                                                                    e.currentTarget.style.color = '#5f6368';
                                                                }
                                                            }}
                                                        >
                                                            <FontAwesomeIcon 
                                                                icon={item.icon} 
                                                                style={{ 
                                                                    width: '18px', 
                                                                    fontSize: '16px',
                                                                    color: isActive ? '#1a73e8' : '#80868b'
                                                                }} 
                                                            />
                                                            <span>{item.name}</span>
                                                        </div>
                                                    </Link>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Sidebar Toggle Buttons */}
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'center', 
                            padding: '12px', 
                            borderTop: '1px solid #e8eaed',
                            marginTop: 'auto'
                        }}>
                            <FontAwesomeIcon 
                                id="id_btn_open" 
                                className="toggle-icon" 
                                icon={faCircleArrowLeft} 
                                onClick={toggleNav} 
                                title="Collapse sidebar" 
                                style={{ 
                                    fontSize: '18px', 
                                    cursor: 'pointer', 
                                    color: '#5f6368',
                                    transition: 'color 0.2s ease'
                                }} 
                                onMouseEnter={(e) => e.currentTarget.style.color = '#1a73e8'}
                                onMouseLeave={(e) => e.currentTarget.style.color = '#5f6368'}
                            />
                            <FontAwesomeIcon 
                                id="id_btn_close" 
                                className="toggle-icon" 
                                icon={faCircleArrowRight} 
                                onClick={toggleNav} 
                                title="Expand sidebar" 
                                style={{ 
                                    fontSize: '18px', 
                                    cursor: 'pointer', 
                                    color: '#5f6368', 
                                    display: 'none',
                                    transition: 'color 0.2s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#1a73e8'}
                                onMouseLeave={(e) => e.currentTarget.style.color = '#5f6368'}
                            />
                        </div>
                    </div>
                </nav>

                <nav id="main-navbar" className="navbar navbar-expand-lg navbar-light bg-white fixed-top navbar-custom" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.08)', backdropFilter: 'blur(8px)' }}>
                    <div className="container-fluid navbar-inner">
                        {/* Left: Connecting Earth Branding */}
                        <div className="navbar-brand-custom d-flex align-items-center" style={{ minWidth: '300px' }}>
                            <div className="branding-container" style={{
                                padding: '10px 18px',
                                background: '#ffffff',
                                border: '1px solid #e0e0e0',
                                borderRadius: '12px',
                                color: '#1d1d1f',
                                fontWeight: '700',
                                fontSize: '16px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.06)',
                                cursor: 'pointer'
                            }}>
                                <FontAwesomeIcon icon={faGlobe} style={{ 
                                    fontSize: '22px', 
                                    animation: 'spin 20s linear infinite',
                                    color: '#5f6368'
                                }} />
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    lineHeight: '1.1'
                                }}>
                                    <span style={{ fontSize: '14px', fontWeight: '800', letterSpacing: '1px', textTransform: 'uppercase' }}>Connecting</span>
                                    <span style={{ fontSize: '14px', fontWeight: '800', letterSpacing: '1px', textTransform: 'uppercase' }}>Earth</span>
                                </div>
                            </div>
                        </div>

                        {/* Center: Current Page Title */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexGrow: 1
                        }}>
                            <div style={{
                                padding: '6px 14px',
                                color: '#1d1d1f',
                                fontWeight: '600',
                                fontSize: '15px'
                            }}>
                                {pageTitle}
                            </div>
                        </div>

                        {/* Center: Quick Actions */}
                        <div className="navbar-actions d-flex gap-2 justify-content-center">
                            <Link to="/device/create" className="action-btn" style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                                padding: '8px 14px',
                                borderRadius: '12px',
                                backgroundColor: '#f6f6f7',
                                color: '#1d1d1f',
                                textDecoration: 'none',
                                fontWeight: '600',
                                fontSize: '12px',
                                transition: 'all 0.2s ease',
                                border: '1px solid #d0d0d4',
                                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.06)',
                                cursor: 'pointer',
                                textTransform: 'none',
                                letterSpacing: '0.2px'
                            }} onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#ededf0';
                                e.currentTarget.style.color = '#000';
                                e.currentTarget.style.transform = 'translateY(-1px)';
                                e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.08)';
                            }} onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#f6f6f7';
                                e.currentTarget.style.color = '#1d1d1f';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0, 0, 0, 0.06)';
                            }}>
                                <FontAwesomeIcon icon={faPlus} />
                                <span>New Device</span>
                            </Link>

                            <Link to="/custom_user/create" className="action-btn" style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                                padding: '8px 14px',
                                borderRadius: '12px',
                                backgroundColor: '#f6f6f7',
                                color: '#1d1d1f',
                                textDecoration: 'none',
                                fontWeight: '600',
                                fontSize: '12px',
                                transition: 'all 0.2s ease',
                                border: '1px solid #d0d0d4',
                                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.06)',
                                cursor: 'pointer',
                                textTransform: 'none',
                                letterSpacing: '0.2px'
                            }} onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#ededf0';
                                e.currentTarget.style.color = '#000';
                                e.currentTarget.style.transform = 'translateY(-1px)';
                                e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.08)';
                            }} onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#f6f6f7';
                                e.currentTarget.style.color = '#1d1d1f';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0, 0, 0, 0.06)';
                            }}>
                                <FontAwesomeIcon icon={faPlus} />
                                <span>New User</span>
                            </Link>

                            <Link to="/organization/create" className="action-btn" style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                                padding: '8px 14px',
                                borderRadius: '12px',
                                backgroundColor: '#f6f6f7',
                                color: '#1d1d1f',
                                textDecoration: 'none',
                                fontWeight: '600',
                                fontSize: '12px',
                                transition: 'all 0.2s ease',
                                border: '1px solid #d0d0d4',
                                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.06)',
                                cursor: 'pointer',
                                textTransform: 'none',
                                letterSpacing: '0.2px'
                            }} onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#ededf0';
                                e.currentTarget.style.color = '#000';
                                e.currentTarget.style.transform = 'translateY(-1px)';
                                e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.08)';
                            }} onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#f6f6f7';
                                e.currentTarget.style.color = '#1d1d1f';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0, 0, 0, 0.06)';
                            }}>
                                <FontAwesomeIcon icon={faPlus} />
                                <span>New Dept</span>
                            </Link>

                            <Link to="/contact/create" className="action-btn" style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                                padding: '8px 14px',
                                borderRadius: '12px',
                                backgroundColor: '#f6f6f7',
                                color: '#1d1d1f',
                                textDecoration: 'none',
                                fontWeight: '600',
                                fontSize: '12px',
                                transition: 'all 0.2s ease',
                                border: '1px solid #d0d0d4',
                                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.06)',
                                cursor: 'pointer',
                                textTransform: 'none',
                                letterSpacing: '0.2px'
                            }} onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#ededf0';
                                e.currentTarget.style.color = '#000';
                                e.currentTarget.style.transform = 'translateY(-1px)';
                                e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.08)';
                            }} onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#f6f6f7';
                                e.currentTarget.style.color = '#1d1d1f';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0, 0, 0, 0.06)';
                            }}>
                                <FontAwesomeIcon icon={faPlus} />
                                <span>New Contact</span>
                            </Link>
                        </div>

                        {/* Right: User Menu */}
                        <ul className="navbar-nav ms-auto d-flex flex-row align-items-center navbar-right-actions" style={{ margin: 0 }}>
                            <li className="nav-item dropdown user-info">
                                <a className="user-profile-link dropdown-toggle" href="#" id="userMenu" role="button" data-bs-toggle="dropdown" aria-expanded="false" title="Profile menu" style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '8px 14px',
                                    borderRadius: '8px',
                                    backgroundColor: '#ffffff',
                                    border: '1px solid #e0e0e0',
                                    color: '#3c4043',
                                    textDecoration: 'none',
                                    fontWeight: '500',
                                    transition: 'all 0.3s ease'
                                }} onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#f5f8ff';
                                    e.currentTarget.style.borderColor = '#d2e3fc';
                                }} onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = '#ffffff';
                                    e.currentTarget.style.borderColor = '#e0e0e0';
                                }}>
                                    <FontAwesomeIcon icon={faUser} style={{ fontSize: '16px' }} />
                                    <span style={{ maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.username || 'User'}</span>
                                    <FontAwesomeIcon icon={faChevronDown} style={{ fontSize: '12px' }} />
                                </a>
                                <ul className="dropdown-menu dropdown-menu-end profile-dropdown-menu" aria-labelledby="userMenu">
                                    <li className="dropdown-header">
                                        <div className="dropdown-user-username" style={{ fontWeight: '600', color: '#333' }}>{user?.email || user?.username}</div>
                                    </li>
                                    <li><Link className="dropdown-item" to="/profile"><FontAwesomeIcon icon={faUser} className="me-2" />My Profile</Link></li>
                                    <li><Link className="dropdown-item" to="/setting"><FontAwesomeIcon icon={faCog} className="me-2" />Settings</Link></li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li><button className="dropdown-item" onClick={logout}><FontAwesomeIcon icon={faSignOut} className="me-2" />Logout</button></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </nav>
            </header>
        </div>
    );
};
